import React from "react";
import CustomModal from "./CustomModal";

function Index(props) {
  return <CustomModal {...props} />;
}

export default Index;
